import { useSrpContext } from '@/src/contexts'
import { RouteFaqItem } from '@/src/types/seoSrpResult'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import CategoryFaq from './categoryFaq'
import { GroupedFaqCategory } from './categoryFaq'

function groupByCategory (items: RouteFaqItem[]): GroupedFaqCategory[] {
    const map = new Map<string, { question: string; answer: string }[]>()
    for (const item of items) {
        const existing = map.get(item.category)
        if (existing) {
            existing.push({ question: item.question, answer: item.answer })
        } else {
            map.set(item.category, [{ question: item.question, answer: item.answer }])
        }
    }
    return Array.from(map, ([category, items]) => ({ category, items }))
}

const ROUTE_FAQ_CATEGORIES = new Set(['booking', 'schedules', 'cancellations', 'support'])

const CategoryFaqWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const faq = sections?.faq
    if (!faq?.length) return null

    const routeFaq = faq.filter(item => ROUTE_FAQ_CATEGORIES.has(item.category))
    if (!routeFaq.length) return null

    const groupedFaq = useMemo(() => groupByCategory(routeFaq), [routeFaq])
    const city = sections?.destination?.info?.title
    const title = city ? t('faqAboutCity', { city }) : ''

    return <CategoryFaq title={title} groupedFaq={groupedFaq} />
}

export default CategoryFaqWrapper
